import type { CircleLayer } from 'react-map-gl';

const MarkersStrokeLayer: CircleLayer = {
  id: "markers-stroke-hover",
  type: "circle",
  paint: {
    "circle-radius": 10,
    "circle-opacity": 0,
    "circle-color": "transparent",
    "circle-stroke-color": "white",
    "circle-stroke-opacity": 0.5,
    "circle-stroke-width": 4
  }
};

export { MarkersStrokeLayer }
